if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.onCartUpdated = this.onCartUpdated.bind(this);
        this.productId = this.dataset.productId || '';
        this.initialized = false;
      }

      connectedCallback() {
        if (this.hasAttribute('data-watch-cart')) {
          document.addEventListener('cart:updated', this.onCartUpdated);
        }

        if (!this.productId) {
          this.toggleSectionVisibility(false);
          return;
        }

        if (this.initialized) return;

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.onCartUpdated);
      }

      init() {
        if (this.initialized || !this.dataset.url || !this.productId) return;
        this.initialized = true;
        this.fetchRecommendations();
      }

      getFirstProductId(cart) {
        if (!cart?.items?.length) return '';

        const giftWrapProductId = this.dataset.giftWrapProductId;

        for (const item of cart.items) {
          if (giftWrapProductId && String(item.product_id) === String(giftWrapProductId)) {
            continue;
          }
          return String(item.product_id);
        }

        return '';
      }

      updateRecommendationsUrl(productId) {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('product_id', productId);
        this.productId = String(productId);
        this.dataset.productId = this.productId;
        this.dataset.url = `${url.pathname}${url.search}`;
      }

      toggleSectionVisibility(visible) {
        const shopifySection = this.closest('.shopify-section');
        const section = this.closest('.section');

        [shopifySection, section].forEach((el) => {
          if (!el) return;
          el.classList.toggle('hidden', !visible);
        });
      }

      onCartUpdated(event) {
        if (!this.hasAttribute('data-watch-cart')) return;

        const nextProductId = this.getFirstProductId(event.detail?.cart);

        if (!nextProductId) {
          this.productId = '';
          this.dataset.productId = '';
          this.toggleSectionVisibility(false);
          this.innerHTML = '';
          return;
        }

        if (String(nextProductId) === String(this.productId)) return;

        this.updateRecommendationsUrl(nextProductId);
        this.initialized = true;
        this.fetchRecommendations();
      }

      fetchRecommendations() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.reinitializeTrustpilotWidgets?.(this);
            }

            if (recommendations?.querySelector('.product-card')) {
              this.toggleSectionVisibility(true);
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (this.hasAttribute('data-watch-cart')) {
                this.toggleSectionVisibility(false);
                this.innerHTML = '';
              } else if (this.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
